<script setup lang="ts">
import { computed } from "vue";
import Icon from "./Icon.vue";

const props = withDefaults(
  defineProps<{
    icon: string;
    label: string;
    variant?: "ghost" | "solid" | "outline";
    size?: "sm" | "md" | "lg";
    disabled?: boolean;
  }>(),
  { variant: "ghost", size: "md" },
);
defineEmits<{ click: [MouseEvent] }>();

const cls = computed(() => [
  "cw-iconbtn",
  `cw-iconbtn--${props.variant}`,
  `cw-iconbtn--${props.size}`,
]);
const glyph = computed(() => (props.size === "sm" ? 16 : props.size === "lg" ? 22 : 19));
</script>
<template>
  <button
    type="button"
    :class="cls"
    :aria-label="label"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <Icon
      :name="icon"
      :size="glyph"
    />
  </button>
</template>
